export function useDistance() {

  // The following 2 functions are copied and slightly modified from
  // https://stackoverflow.com/questions/1502590/calculate-distance-between-two-points-in-google-maps-v3
  // to calculate the distance in meters between 2 coordinates. This functionality
  // is to be considered inexact and not necessarily a permanent and scalable
  // solution.
  const rad = (x) => {
    return (x * Math.PI) / 180
  }

  const getDistance = (p1, p2) => {
    p1.lat = parseFloat(p1.lat)
    p1.lng = parseFloat(p1.lng)
    p2.lat = parseFloat(p2.lat)
    p2.lng = parseFloat(p2.lng)

    if (isNaN(p1.lat) || isNaN(p1.lng)) {
      throw new Error('Invalid coordinate p1: ' + JSON.stringify(p1))
    }

    if (isNaN(p2.lat) || isNaN(p2.lng)) {
      throw new Error('Invalid coordinate p2: ' + JSON.stringify(p2))
    }

    // Earth’s mean radius in meters.
    const earthRadius = 6378137
    const dLat = rad(p2.lat - p1.lat)
    const dLong = rad(p2.lng - p1.lng)
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(rad(p1.lat)) *
      Math.cos(rad(p2.lat)) *
      Math.sin(dLong / 2) *
      Math.sin(dLong / 2)
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))

    // Returns the distance in meter.
    return earthRadius * c
  }

  return {
    getDistance,
  }
}